export default __webpack_public_path__ + "d527546ac918fdc8371012a03c5df06b.svg";